













import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "Selector",
})
export default class Selector extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return;
    },
  })
  required!: boolean;
  @Prop({
    type: Array,
  })
  items!: string[];
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  value!: string;

  // data
  private classes: any = {
    "lfs-pd-input-block-requred": this.required,
  };
  private placeholder: string = "";
  item: string = this.value;
  //   methods
  handleInput() {
    this.$emit("input", this.item);
  }
}
